/* src/app/dialogs/info-dialog/info-dialog.component.scss */
.error-title {
  color: #f44336;
}
/*# sourceMappingURL=info-dialog.component.css.map */
